import { useEscapeKey } from '../../utils/hooks/useEscapeKey';
import PortalComponent from '../Portal';
import styles from './RightSidePanel.module.scss';

export default function RightSidePanel({ visible, closePanel, children }) {
    useEscapeKey(closePanel);

    return (<PortalComponent>
        <div className={`${styles.rightSidePanelLayer} ${visible ? styles[`visible-layer`] : ''}`} onClick={closePanel} />
        <div className={`${styles.rightSidePanelWrapper} ${visible ? styles[`visible-${visible}`] : ''}`}>
            {visible ? children : null}
        </div>
    </PortalComponent>);
}